export const MIRAGE_SCENARIOS: Readonly<Record<string, string>> = {
	ADDITIONAL_SPEC: 'additionalSpec',
	ADDITIONAL_VEHICLE_DETAILS: 'additionalVehicleDetails',
	BUY_IT_NOW: 'buyItNow',
	CYPRESS: 'cypress',
	DEALER_ACCOUNT_FROZEN: 'dealerAccountFrozen',
	DEFAULT: 'default',
	DELIVERY_FERRY_OR_ERROR: 'deliveryFerryOrError',
	ESTIMATED_DELIVERY_COST: 'estimatedDeliveryCost',
	HERO_IMAGES: 'heroImages',
	HERO_IMAGES_LOAD_TEST: 'heroImagesLoadTest',
	INSIGHTS_RECENT_SOLD_PRICES: 'insightsRecentSoldPrices',
	MOT_DETAILS: 'motDetails',
	NEGATIVE_EQUITY_AWAITING_SELLER_FUNDS: 'negativeEquityAwaitingSellerFunds',
	NEGATIVE_EQUITY_SELLER_FUNDS_RECEIVED: 'negativeEquitySellerFundsReceived',
	PAYMENT_OPTION_UNAVAILABLE: 'paymentOptionUnavailable',
	PENDING_BID_OR_OFFER: 'pendingBidOrOffer',
	SERVICE_RECORD: 'serviceRecord',
	SIMILAR_VEHICLES: 'similarVehicles',
	SIMULATE_SALE_TIMES: 'simulateSaleTimes',
	SKIP_SALE_DAY: 'skipSaleDay',
	TEST_ERROR_STATES_AND_LOGGING: 'testErrorStatesAndLogging',
	THOUSAND_CARS: 'thousandCars',
	TRADE_VEHICLES: 'tradeVehicles',
	VEHICLE_DETAILS: 'vehicleDetails',
	VEHICLE_HISTORY_CHECKS: 'vehicleHistoryChecks',
};
